import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, SITE_URL } from "@/content/seo";
import { landingContent, pageFaqLD } from "@/content/landing-content";

const TITLE = "Boat Hire Algarve · Private Crewed Yacht · Morningstar";
const DESC =
  "Boat hire in the Algarve aboard Morningstar — a 200 m² private crewed yacht from Marina de Vilamoura, for up to 18 guests. All-inclusive: crew, fuel, drinks, tapas.";
const PATH = "/boat-hire-algarve";
const URL = `${SITE_URL}${PATH}`;
const CONTENT = landingContent.boatHireAlgarve;

export const Route = createFileRoute("/boat-hire-algarve")({
  component: () => (
    <SitePage
      lang="en"
      heroOverride={{
        eyebrow: CONTENT.en.eyebrow,
        title: "Boat hire in the Algarve on ",
        titleAccent: "Morningstar.",
        sub: "A fully crewed 200 m² private yacht from Marina de Vilamoura, up to 18 guests. All-inclusive — crew, fuel, drinks, Portuguese tapas. No licence required.",
        ctaPrimary: "View hire options",
        ctaSecondary: "Request a quote",
      }}
      pageContent={CONTENT.en}
    />
  ),
  head: () =>
    buildHead({
      lang: "en",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords:
        "boat hire algarve, boat hire algarve portugal, algarve boat rental, yacht hire algarve, private boat hire algarve",
      altPath: { en: PATH, pt: "/pt/aluguer-de-barco-algarve" },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Boat Hire in the Algarve",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Home", path: "/" },
              { name: "Boat Hire Algarve", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(pageFaqLD(CONTENT.en.faqs)) },
      ],
    }),
});